module.exports = __webpack_public_path__ + "pin_lightgrey.327dd0.png";